<template>
  <div id="">
    <v-container grid-list-xl fluid>
     
        <v-layout row wrap>
          <v-flex md12 sm12 class="my-4">
              <h3>CAJERO GN / ARCHIVOS</h3>
          </v-flex>
          <v-flex xs12 md6 lg6>
            <v-text-field label="Buscar por Nombre ATM..." v-model="name"></v-text-field>
          </v-flex>
          <v-flex xs12 md6 lg6>
            <v-text-field label="Buscar por ID ATM..." v-model="identificador"></v-text-field>
          </v-flex>
          <!--<v-flex xs12 md4 lg4>
            <v-text-field label="Buscar por N Serie..." v-model="serie"></v-text-field>
          </v-flex>-->
         <!-- <v-flex xs12 md6 lg6>
            <v-select
              :items="types"
              label="Filtrar Tipo"
              item-text="text"
              item-value="value"
              v-model="type"
            ></v-select>
          </v-flex>
          <v-flex xs12 md6 lg6>
            <v-select
              :items="statusfilter"
              label="Filtrar Estado"
              item-text="text"
              item-value="value"
              v-model="statusfilterSelect"
            ></v-select>
          </v-flex> -->
          <v-btn color="success" @click="getList()">Buscar</v-btn>
          <download-excel :data="json_data" :fields="json_fields">
            <v-btn color="blue-grey" class="white--text" :disabled="loaderExcel">
              <v-icon right dark>assignment_returned</v-icon>Descargar Excel
            </v-btn>
          </download-excel>
        </v-layout>
       <!-- <v-divider></v-divider>-->
        <v-progress-circular
          indeterminate
          :size="40"
          v-if="generalLoader == true"
          style="position: fixed; bottom: 10%; right: 5%;"
          color="primary"
        ></v-progress-circular>

        <v-data-table
          hide-actions
          :headers="complex.headers"
          :items="complex.items"
          item-key="name"
        >
          <template slot="items" slot-scope="props">
            <td>
              
              <v-tooltip bottom color="info">
                <template v-slot:activator="{ on }">
                  <v-btn
                    flat
                    icon
                    color="info"
                    v-on="on"
                    @click="viewDetail( props.item.agents )"
                    :disabled="loader.saveBtn"
                  >
                    {{ props.item.agents }}
                  </v-btn>
                </template>
                 <span>Ver información del ATM</span>
              </v-tooltip>
             </td>
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.direction | truncate(10, '...') }}</td>
            <td>{{ props.item.district }}</td>
            <td>{{ props.item.province }}</td>
            <td>
              <v-chip
                v-if="props.item.FF"
                :disabled="loader.saveBtn"
                :color="getColor(props.item.FF.status)"
                dark
                @click="dialog= true; getData(props.item.FF);"
              >{{ props.item.FF.status }}</v-chip>

              <v-chip v-else dark>SIN INFORMACIÓN</v-chip>
            </td>
            <td>
              <v-chip
                v-if="props.item.LL"
                :disabled="loader.saveBtn"
                :color="getColor(props.item.LL.status )"
                dark
                @click="dialog= true; getData(props.item.LL);"
              >{{ props.item.LL.status }}</v-chip>

              <v-chip v-else dark>SIN INFORMACIÓN</v-chip>
            </td>
            <td>
              <v-chip
                v-if="props.item.DNI"
                :disabled="loader.saveBtn"
                :color="getColor(props.item.DNI.status)"
                dark
                @click="dialog= true; getData(props.item.DNI);"
              >{{ props.item.DNI.status }}</v-chip>

              <v-chip v-else dark>SIN INFORMACIÓN</v-chip>
            </td>
            <td>
              <v-chip
                v-if="props.item.AP"
                :disabled="loader.saveBtn"
                :color="getColor(props.item.AP.status)"
                dark
                @click="dialog= true; getData(props.item.AP);"
              >{{ props.item.AP.status }}</v-chip>

              <v-chip v-else dark>SIN INFORMACIÓN</v-chip>
            </td>

            <td>
              <v-chip
                v-if="props.item.FDJ"
                :disabled="loader.saveBtn"
                :color="getColor(props.item.FDJ.status)"
                dark
                @click="dialog= true; getData(props.item.FDJ);"
              >{{ props.item.FDJ.status }}</v-chip>

              <v-chip v-else dark>SIN INFORMACIÓN</v-chip>
            </td>


            <!--<td >
              <v-tooltip bottom color="info">
                <template v-slot:activator="{ on }">
                  <v-btn
                    flat
                    icon
                    color="info"
                    v-on="on"
                    @click="viewDetail( props.item.agents )"
                    :disabled="loader.saveBtn"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>
              </td>-->
          </template>
        </v-data-table>
 <v-layout row wrap >
        <div class="text-center pt-2">
          <v-pagination
            v-model="page"
            :length="pageCount"
            @input="getList()"
            @next="getList()"
            @previous="getList()"
          ></v-pagination>
        </div>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Información de Archivo</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <h2>Datos</h2>
                <!--<p>
                  <strong>Solicitud:</strong>
                  {{ form.type }}
                </p>
                <p>
                  <strong>Fecha de Solicitud:</strong>
                  {{ form.request }}
                </p>
                <p>
                  <strong>Fecha de Entrega:</strong>
                  {{ form.request_exp }}
                </p>
                <p>
                  <strong>Fecha de Emisión:</strong>
                  {{ form.date }}
                </p>
                <p>
                  <strong>Fecha de Vencimiento:</strong>
                  {{ form.exp_date }}
                </p>
                <p>
                  <strong>Número del Autorización:</strong>
                  {{ form.num }}
                </p>
                <p>
                  <strong>Número del Serie:</strong>
                  {{ form.serie }}
                </p>
                <p>
                  <strong>Observaciones:</strong>
                  {{ form.observations }}
                </p>
                <p>
                  <strong>Estado:</strong>
                  {{ form.status }}
                </p>
                <p>-->
                  <v-col cols="12" sm="6" md="4" v-if="form.attachment">
                    <v-flex md12 sm12>
                      <v-btn
                      small
                        color="info"
                        @click="getAttachament(form.attachment)"
                      ><v-icon>remove_red_eye</v-icon> Ver documento adjunto</v-btn>
                      <v-btn
                      small
                        color="info"
                        @click="downloadAttachament(form.attachment)"
                      ><v-icon>assignment_returned</v-icon> Descargar documento adjunto</v-btn>
                    </v-flex>
                    
                    
                  </v-col>
                </p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-center">
          <div class="flex-grow-1"></div>
          <v-btn text @click="dialog = false" :disabled="loader.saveBtn">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar :timeout="3000" top right :color="snackbar.color" v-model="snackbar.show">
      <p style="margin: 0">
        <i :class="snackbar.icon"></i>
        &nbsp;
        {{ snackbar.text }}
      </p>
      <v-btn dark flat @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-icon></v-icon>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "@/api/axios/config";
import JsonExcel from "vue-json-excel";
import base_url from '@/api/axios/base_url';
Vue.component("downloadExcel", JsonExcel);
export default {
  data() {
    return {
      search: "",
      isEdit: false,
      id: null,
      page: 1,
      itemsPerPage: 50,
      pageCount: 0,
      name: "",
      value: "",
      type: "",
      statusfilterSelect: "",
      identificador: "",
      serie: "",
      description: "",
      loader: false,
      saveBtn: false,
      rules: {
        required: value => !!value || "Campo requerido."
      },
      appEvents: [],
      complex: {
        headers: [
          {
            text: "ATM",
            value: "agent_id"
          },
          {
            text: "Nombre",
            value: ""
          },
          {
            text: "Dirección",
            value: ""
          },
          {
            text: "Distrito",
            value: ""
          },
           {
            text: "Provincia",
            value: ""
          },
          {
            text: "Foto fachada",
            value: ""
          },
          {
            text: "Licencia Local",
            value: ""
          },
          {
            text: "DNI",
            value: ""
          },
          {
            text: "Autorización del propietario",
            value: ""
          },
          {
            text: "Formato DJ",
            value: ""
          },
          {
            text: "",
            value: ""
          }
        ],
        items: []
      },
      types: [
        	{ value: "DNI", text: "DNI" },
          { value: "LICENCIA LOCAL", text: "Licencia Local" },
          { value: "FOTO FACHADA", text: "Foto Fachada" },
          { value: "AUTORIZACION DEL PROPIETARIO", text: "Autorización del Propietario" },
          { value: "FORMATO DJ", text: "Formato DJ" }
      ],
      status: [
        { value: "PENDIENTE", text: "Pendiente" },
        { value: "EN CURSO", text: "En curso" },
        { value: "COMPLETADO", text: "Completado" },
        { value: "RECHAZADO", text: "Rechazado" }
      ],
      statusfilter: [
        { value: "PENDIENTE", text: "Pendiente" },
        { value: "EN CURSO", text: "En curso" },
        { value: "VENCIDAD", text: "Solicitud Vencidad" }
      ],
      snackbar: {
        show: false,
        text: "",
        color: "",
        icon: ""
      },
      basic: {
        dialog: false
      },
      dialog: false,
      saveLoader: false,
      removeLoader: false,
      generalLoader: false,
      modalLoader: false,
      disabled: false,
      loaderExcel: false,
      form: {
        agent_id: "",
        num: "",
        serie: "",
        sign_type: "",
        type: "",
        date: "",
        attachment: "",
        exp_date: "",
        status: "",
        observations: "",
        agents: []
      },
      json_fields: {
        ATM: "agents",
        Nombre: "name",
        Dirección: "direction",
        Distrito: "district",
        Provincia: "province",
        Departamento: "department",
        "Declaración Jurada": "DJ",
        "Exp. N°": "num",
        "N° Serie": "serie",
        "Fecha de Solicitud": "request",
        "Fecha de Entrega": "request_exp",
        "Fecha de Emisión": "date",
        "Fecha de vencimiento": "exp_date",
        Licencia: "LC",
        "Exp. N°": "num",
        "N° Serie": "serie",
        "Fecha de Solicitud": "request",
        "Fecha de Entrega": "request_exp",
        "Fecha de Emisión": "date",
        "Fecha de vencimiento": "exp_date",
        "Autorización de Anuncio": "LC",
        "Exp. N°": "num",
        "N° Serie": "serie",
        "Fecha de Solicitud": "request",
        "Fecha de Entrega": "request_exp",
        "Fecha de Emisión": "date",
        "Fecha de vencimiento": "exp_date",
        "Norma Legal": "NL",
        "Exp. N°": "num",
        "N° Serie": "serie",
        "Fecha de Solicitud": "request",
        "Fecha de Entrega": "request_exp",
        "Fecha de Emisión": "date",
        "Fecha de vencimiento": "exp_date"
      },
      json_data: []
    };
  },
  filters: {
    formatDate: function(date) {
      if (date != null && date != "") {
        return moment(date).format("DD-MM-YYYY");
      }
    },
    truncate: function(text, length, suffix) {
      return text.substring(0, length) + suffix;
    }
  },
  mounted() {
    this.getList();
    this.getListExcel();
  },
  methods: {
    getList() {
      this.generalLoader = true;
      axios
        .get(
          "gn/agentes-archivos?" +
            "name=" +
            this.name +
            "&identificador=" +
            this.identificador +
            "&type=" +
            this.type +
            "&status=" +
            this.statusfilterSelect +
            "&serie=" +
            this.serie +
            "&page=" +
            this.page +
            "&limit=50"
        )
        .then(response => {
          this.complex.items = response.data.data.items;
          this.pageCount = response.data.data.total;
          this.generalLoader = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getColor(status) {
      if (status == "EN CURSO") return "info";
      else if (status == "PENDIENTE") return "warning";
      else if (status == "COMPLETADO") return "success";
      else if (status == "VENCIDAD") return "error";
      else if (status == "VENCIDOD") return "error";
    },
    getListExcel() {
      this.loaderExcel = true;
      axios
        .get(
          "gn/agentes-archivos-all?" +
            "name=" +
            this.name +
            "&page=" +
            this.page +
            "&limit=50"
        )
        .then(response => {
          this.json_data = response.data.data.items;
          this.loaderExcel = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    clearInputs() {
      this.name = "";
      this.value = "";
      this.description = "";
    },
    getData(data) {
      this.form = data;
    },
    getAttachament(url) {
      window.open(url, "_blank");
    },

    downloadAttachament(urlArchivo) {
      axios
        .get(
          "gn/nueva-data-2/downloadFile?" +
            "urlFile=" +
            urlArchivo
        ,{
          responseType: 'blob'
        })
        .then(response => {
          let nameFile = urlArchivo.split("/");
         const url = window.URL.createObjectURL(new Blob([response.data]));
         const link = document.createElement('a');
         link.style = "display:none";
         link.href = url;
         link.setAttribute('download', nameFile[nameFile.length - 1]); //or any other extension
         document.body.appendChild(link);
         link.click();
              })
              .catch(error => {
                console.log(error);
              });
    },

    viewDetail(id) {
      this.$router.push("/GN/archivos-gn/archivo-detalle-gn/" + id);
    },
  }
};
</script>

<style>

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>